import {
  CSSProperties,
  ElementType,
  KeyboardEventHandler,
  MouseEventHandler,
  ReactNode,
} from "react";

import { cx, styled } from "simplydo/react/styled";

import { Icon } from "../icon";

export type LabelDetailProps = {
  as?: ElementType | string;
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
  onClick?: MouseEventHandler<HTMLElement>;
  onKeyDown?: KeyboardEventHandler<HTMLElement>;
  role?: string;
  tabIndex?: number;
};

const StyledLabelDetail = styled.span`
  display: inline-block;
  margin-left: 0.5em;
  font-weight: bold;
  opacity: 0.8;
  vertical-align: middle;

  ${Icon} {
    margin: 0;
  }
`;

const LabelDetailComponent = (props: LabelDetailProps) => {
  const { as, children, className, style, onClick, ...rest } = props;
  const Tag = (as || "span") as ElementType;
  return (
    <StyledLabelDetail
      as={Tag}
      className={cx(className)}
      style={style}
      onClick={onClick}
      {...rest}
    >
      {children}
    </StyledLabelDetail>
  );
};

export const LabelDetail = styled(LabelDetailComponent)``;
